import axiosInstance from "./AxiosInstance";


export const getChatHistory = async () => {
  try {
    const response = await axiosInstance.get("api/chat/history");
    return response.data?.data || [];
  } catch (error) {
    console.error("Error fetching chat history:", error);
    throw error;
  }
};

export const saveChat = async (chatMessages, imageFile = null) => {
  try {
    const formData = new FormData();

    formData.append("chat_messages", JSON.stringify(chatMessages));

    if (imageFile) {
      formData.append("images", imageFile);
    }

    const response = await axiosInstance.post("api/chat/save", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("Error saving chat:", error);
    throw error;
  }
};


export const getPlan = async () => {
  try {
    const response = await axiosInstance.get("/api/fitbot/weekly-data");
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error);
    throw error;
  }
};

export const fiBotChat = async (formData) => {
  try {

    const response = await axiosInstance.post("api/fitbot-chat", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("Error saving chat:", error);
    throw error;
  }
};
